import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormTextInput } from ".";

interface FormInputProps {
  autoFocus?: boolean;
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  register: any;
  step?: string;
  // name?: string;
}
export default function FormNumberInput({
  label,
  required,
  errors,
  autoFocus,
  register,
  step,
  // name,
}: FormInputProps) {
  // console.log(register);
  return (
    <FormTextInput
      errors={errors}
      label={label}
      required={required}
      autoFocus={autoFocus}
      type="number"
      step={step ?? "1"}
      register={register}
      // name={name}
      onWheel={(e: any) => {
        e.preventDefault(); // Prevents changing the value when scrolling
      }}
      className={cn("text-base", { "border-danger-500": errors?.error })}
    />
  );
}
